import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { tIndustryTypes } from 'src/pages/Auth/CreateWorkspace/CreateWorkspace.types';
import { CreateWorkspaceService } from 'src/pages/Auth/CreateWorkspace/CreateWorkspace.service';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';
import {
  tAddWorkspaceModalForm,
  tAddWorkspaceModalHook,
} from './AddWorkspaceModal.types';
import { useFormik } from 'formik';
import { useWorkspaceContext } from 'src/providers/WorkspaceProvider/Workspace.context';
import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';
import { useToastContext } from 'src/providers/ToastProvider/Toast.hook';
import { AddWorkspaceModalSchema } from './AddWorkspaceModal.schema';
import { useUserContext } from 'src/providers/UserProvider/User.context';
import { eAlertType } from 'src/providers/ToastProvider/Toast.enum';
import { useTranslation } from 'react-i18next';

export default function useAddWorkspaceModal(): tAddWorkspaceModalHook {
  const { onCreateWorkspaceSubmit, getAllWorkspaces } = useWorkspaceContext();
  const { setAddWorkspaceModalIsOpen } = useModalsContext();
  const { addAlert } = useToastContext();
  const { currentUser } = useUserContext();
  const { t } = useTranslation('sidebar/sidebarComponent');

  const [IndustryTypesList, setIndustryTypesList] = useState<
    tIndustryTypes | undefined
  >(undefined);

  const AddWorkspaceInitialValues: tAddWorkspaceModalForm = {
    companyName: '',
    companyType: 1,
    phoneNumber: currentUser?.phoneNumber?.toString() || '',
    countryCode: 'MX',
  };

  const addWOrkspaceFormikConfig = {
    initialValues: AddWorkspaceInitialValues,
    validationSchema: AddWorkspaceModalSchema(t),
    onSubmit: createWorkspace,
    enableReinitialize: true,
  };

  const addWorkspaceFormik = useFormik(addWOrkspaceFormikConfig);

  useEffect(() => {
    (async () => {
      if (!isEmpty(IndustryTypesList)) return;
      try {
        const response = await CreateWorkspaceService.getIndustryTypes();
        setIndustryTypesList(response.data);
      } catch (err) {
        LLog.error(
          {
            component: LOG_COMPONENTS.AUTH,
            method: 'CreateWorkspace.hook',
            operation: LOG_OPERATIONS.ERROR,
          },
          'Error in CreateWorkspace.hook',
          err as Error,
        );
      }
    })();
  }, []);

  async function createWorkspace(formData: tAddWorkspaceModalForm) {
    try {
      await onCreateWorkspaceSubmit(formData);
      if (!currentUser) return;
      getAllWorkspaces();
    } catch (error) {
      addAlert({
        type: eAlertType.ERROR,
        message: (error as Error)?.message ?? 'Error al crear workspace',
      });
    }
    setAddWorkspaceModalIsOpen(false);
  }

  return {
    IndustryTypesList,
    addWorkspaceFormik,
  };
}
